module.exports = __webpack_public_path__ + "img/imagenCuatroCallCenter.191a3d33.png";